export const SESSION_STORAGE_KEYS = {
	REDIRECT: 'redirect-to',
	WORKSPACE_INVITE_TOKEN: 'workspace-invite-token',
	SHARE_LINK_OPENED: 'share-link-opened',
} as const
